import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import {
    Container,
    Row,
    Col,
    Card
} from "kepler";
import { parseMessages } from '../../utilityHelper';

const templateData = $('body').data();
const propertyInfo = parseMessages('directmodel/home');

export default class DirecModel extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div id="directModelWrapper" className="row">
                <Container className="container">
                    <Card className="enroll showconsent">
                        <Row className="rowMargin">
                            <Col>
                                <div className="consentStmt"> 
                                <p><h4>{propertyInfo.directmodel.consent.note1}</h4></p>
                                    <p>{propertyInfo.directmodel.consent.subnote}</p>
                                    <ul className="agreement">
                                        <li>{propertyInfo.directmodel.consent.note1a}</li>
                                        <li>{ ReactHtmlParser(propertyInfo.directmodel.consent.note1b) }</li>
                                        <li>{propertyInfo.directmodel.consent.note1c}</li>
                                        <li>{propertyInfo.directmodel.consent.note1d}</li>
                                        <li>{propertyInfo.directmodel.consent.note1e}</li>
                                        <li>{ ReactHtmlParser(propertyInfo.directmodel.consent.note1f) }</li>
                                    </ul>
                                    <p>{propertyInfo.directmodel.consent.bottomnote1}</p>
                                    <p><h4>{propertyInfo.directmodel.consent.note2}</h4></p>
                                    <ul className="agreement">
                                        <li>{propertyInfo.directmodel.consent.note2a}</li>
                                        <li>{propertyInfo.directmodel.consent.note2b }</li>
                                        <li>{ ReactHtmlParser(propertyInfo.directmodel.consent.note2c) }</li>
                                    </ul>
                                    <p>{propertyInfo.directmodel.consent.bottomnote2}</p>
                                    <p><h4>{propertyInfo.directmodel.consent.note3}</h4></p>
                                    <ul className="agreement">
                                        <li>{propertyInfo.directmodel.consent.note3a}</li>
                                    </ul>
                                    <p>{propertyInfo.directmodel.consent.bottomnote3}</p>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </Container>
            </div>
        );

    }
}


// WEBPACK FOOTER //
// ./directmodel/components/termsandconditions.js